/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_InactiveInputs */

const cs_listing_portals_inactive = /** @type {(inputs: Listing_Portals_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastaveno`)
};

const en_listing_portals_inactive = /** @type {(inputs: Listing_Portals_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Listing_Portals_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_inactive = /** @type {((inputs?: Listing_Portals_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_inactive(inputs)
	return cs_listing_portals_inactive(inputs)
});